import { useLayoutEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { APP_MAIN_SCROLL_ELEMENT_ID, CONTENT_SCROLL_CONTAINER_ID } from '../wf-constants'

/** Resets scroll when the route pathname changes (app shell scroll containers and window). */
const useScrollWindowToTop = (): void => {
  const { pathname } = useLocation()

  useLayoutEffect(() => {
    // The app has two scroll containers depending on the layout; reset whichever is present.
    for (const id of [APP_MAIN_SCROLL_ELEMENT_ID, CONTENT_SCROLL_CONTAINER_ID]) {
      document.getElementById(id)?.scrollTo(0, 0)
    }
    window.scrollTo(0, 0)
  }, [pathname])
}

export default useScrollWindowToTop
